import { render, staticRenderFns } from "./PresentationChat.vue?vue&type=template&id=87ed274a&scoped=true&"
import script from "./PresentationChat.vue?vue&type=script&lang=js&"
export * from "./PresentationChat.vue?vue&type=script&lang=js&"
import style0 from "./PresentationChat.vue?vue&type=style&index=0&id=87ed274a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ed274a",
  null
  
)

export default component.exports